import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/base/base.service';
import { Constants, SearchOperations } from '../../../app.constants';
import CustomStore from 'devextreme/data/custom_store';
import { RequestService } from '../../../core/request.service';
import { AlertService } from '../../../core/alert.service';

@Injectable({
  providedIn: 'root'
})
export class CustomersService extends BaseService {

  protected totalCount: number;

  constructor(protected requestService: RequestService, private alertService: AlertService) {
    super(requestService);
  }

  public getUsersByRole(role: string) {
    let intialfilter = `userType${SearchOperations.EQUALITY}${role}`;
    let url = `${Constants.contextPath}/users`;
    let sortBy = `dateCreated`;
    let sortOrder = `asc`;
    let fields = [`name`, `email`,`login`,`active`];    
    
    return {
      paginate: true,
      pageSize: this.pageSize,
      store: new CustomStore({
        key: 'id',
        load: (loadOptions: any) => {
          if(loadOptions.sort[0] && loadOptions.sort[0].selector){
              sortBy = loadOptions.sort[0].selector;
              sortOrder = loadOptions.sort[0].desc ? 'desc' : 'asc';
          }                  

           let filter = '';
          if (sortBy != null)
            filter = `&${SearchOperations.KEY_SEARCH}=${SearchOperations.LEFT_PARENTHESES_READABLE}${intialfilter}${SearchOperations.RIGHT_PARENTHESES_READABLE}&sortBy=${sortBy}&sortOrder=${sortOrder}`;
          if (loadOptions.filter && loadOptions.filter.length > 0) {

            let fieldsFilter = '';

            if (fields != null && fields.length > 0) {
              let counter = 0;
              for (let field of fields) {
                let searchValue = '';                
                
                if(loadOptions.filter[0] && loadOptions.filter[0].filterValue){
                  let index = loadOptions.filter.findIndex(x=>x[0]==field);
                  searchValue = index != -1 ? loadOptions.filter[index].filterValue : '';                  
                }
                else if(loadOptions.filter.filterValue && loadOptions.filter[0]==field)
                  searchValue = loadOptions.filter.filterValue;

                if(field != 'active'){
                  let OR = `${SearchOperations.KEY_OR}`;
                  
                  if (fieldsFilter=='')
                    OR = '';

                  if(searchValue)
                    fieldsFilter = fieldsFilter + `${OR}${SearchOperations.LEFT_PARENTHESES_READABLE}${field}${SearchOperations.LIKE}${searchValue}${SearchOperations.RIGHT_PARENTHESES_READABLE}`;
                }else{
                  let AND = `${SearchOperations.KEY_AND}`;
                  if (fieldsFilter=='')
                  AND = '';

                  if(searchValue)
                    fieldsFilter = fieldsFilter + `${AND}${SearchOperations.LEFT_PARENTHESES_READABLE}${field}${SearchOperations.EQUALITY}${searchValue}${SearchOperations.RIGHT_PARENTHESES_READABLE}`;
                }                
                counter++;
              }
            }
            filter = `&${SearchOperations.KEY_SEARCH}=${fieldsFilter}${SearchOperations.RIGHT_PARENTHESES_READABLE}${SearchOperations.KEY_AND}${SearchOperations.LEFT_PARENTHESES_READABLE}${intialfilter}${SearchOperations.RIGHT_PARENTHESES_READABLE}&sortBy=${sortBy}&sortOrder=asc`;
          }

          return this.getAllAsPromise(url, loadOptions.skip ? loadOptions.skip : 0, filter, null, (response: any) => {
            return {
              data:       response.content,
              totalCount: response.totalElements
          };
          });
        },
        byKey: (id: any) => {
          return id;
        }
      })
    };
  }
}
